/*
 * @Author: AnNa
 * @Date: 2021-08-09 10:27:41
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-10 17:33:15
 * @Description:
 */
import { axios } from '@/utils/request'

const api = {
  QueryProductList: '/611085f461888',
  QueryGoodInfo: '/6110d1e6505fc',
  PushTaskOfPyq: '/611095201525e',
  QueryCitIds: '/6110e3e976e56',
  QueryListOfPyq: '/61109d194069e',
  QueryListOfMessage: '/6110e0db5cd31',
  CreateMessage: '/6110d6b048636',
  DeleteMessage: '/6110dd8432fcc',
  EditMessage: '/6110d93ab3f12',
  QueryConfigOfPyq: '/6110ec52736d6',
  SaveConfigOfPyq: '/6110eacb80204',
  DeleteTaskOfPyq: '/6110de1ae0649',
  EditTaskOfPyq: '/6110c0784c0f2'
}

/** 编辑朋友圈任务 */
export const editTaskOfPyq = params => {
  return axios({
    method: 'post',
    url: api.EditTaskOfPyq,
    data: params
  })
}

/** 删除朋友圈任务 */
export const deleteTaskOfPyq = params => {
  return axios({
    method: 'get',
    url: api.DeleteTaskOfPyq,
    params
  })
}

/** 保存朋友圈配置 */
export const saveConfigOfPyq = params => {
  return axios({
    method: 'post',
    url: api.SaveConfigOfPyq,
    data: params
  })
}

/** 添加评论模板 */
export const createMessage = params => {
  return axios({
    method: 'post',
    url: api.CreateMessage,
    data: params
  })
}

/** 获取朋友圈配置 */
export const queryConfigOfPyq = params => {
  return axios({
    method: 'get',
    url: api.QueryConfigOfPyq,
    params
  })
}

/** 删除评论模板 */
export const deleteMessage = params => {
  return axios({
    method: 'get',
    url: api.DeleteMessage,
    params
  })
}

/** 编辑评论模板 */
export const editMessage = params => {
  return axios({
    method: 'post',
    url: api.EditMessage,
    data: params
  })
}

/** 获取商品列表 */
export const queryProductList = params => {
  return axios({
    method: 'get',
    url: api.QueryProductList,
    params
  }).then(({ data }) => {
    return {
      total: data.totalNum,
      data: data.list
    }
  })
}

/** 查询商品详情 */
export const queryGoodInfo = params => {
  return axios({
    method: 'get',
    url: api.QueryGoodInfo,
    params
  })
}

/** 添加任务 */
export const PushTaskOfPyq = params => {
  return axios({
    method: 'post',
    url: api.PushTaskOfPyq,
    data: params
  })
}

/** 获取选品库分类IDS */
export const queryCitIds = () => {
  return axios({
    method: 'get',
    url: api.QueryCitIds
  })
}

/** 获取朋友圈任务列表 */
export const queryListOfPyq = params => {
  const data = Object.assign(params, {
    page: params.pageNo || 1,
    size: params.pageSize || 20
  })

  return axios({
    method: 'get',
    url: api.QueryListOfPyq,
    params: data
  }).then(res => {
    return {
      data: res.data.list || [],
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      totalCount: res.data.count
    }
  })
}

/** 获取朋友圈评论列表 */
export const queryListOfMessage = params => {
  const data = Object.assign(params, {
    page: params.pageNo || 1,
    size: params.pageSize || 20
  })

  return axios({
    method: 'get',
    url: api.QueryListOfMessage,
    params: data
  }).then(res => {
    return {
      data: res.data.list || [],
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      totalCount: res.data.count
    }
  })
}
